import CarouselArticleSection from './CarouselArticleSection';

export { default as CarouselArticleSectionTheme } from './CarouselArticleSection.style';
export default CarouselArticleSection;
